<template>
    <dt>
        <label>{{ field.label }}</label>
        <validation-results :validationResults="validationResults" />
    </dt>
    <dd>
        <div v-if="field.options?.valueList">
        <div class="form-check" v-for="(item) in field.options.valueList">
            <input class="form-check-input" type="radio" id="one" :value="item.value" v-model="proxyValue"  :disabled="disabled" />
            <label class="form-check-label">{{item.text}}</label>
        </div>
    </div>
    </dd>
 
</template>
 
  
<script lang="ts">
import { Inject, Options, Prop, Vue, Watch } from 'vue-property-decorator';  
import {FieldValidationResult, FormField, setProxyValue} from './Forms';  
import ValidationResults from './ValidationResults.vue';
 
@Options({components:{ValidationResults}})
export default class RadioList extends Vue
{  
   @Prop() public field!: FormField;
   @Prop() public data!: any;
   @Prop() public validationResults!: FieldValidationResult[];
   @Prop({default:false}) public disabled!: boolean;

   public proxyValue="";

   @Watch("proxyValue")
   public proxyValueChanged()
   {
     this.data[this.field.name] = this.proxyValue;
   }

   public mounted()
   {
     setProxyValue(this);
   }
}

</script>